<template>
  <div>
    <NavTop class="navbar"></Navtop>
    <!-- 内容 -->
    <div class="con content">
      <div class="con_">
        <div class="con_title">
          <div class="con_title1">{{ bigTitle }}</div>
          <div class="con_title2">
            <span @click="routerpush('/')">首页</span>
            <span>/{{ bigTitle }}</span>
          </div>
        </div>
        <div class="con_box">
          <div class="con_box_title">{{ detailData.title }}</div>
          <div class="con_box_time">作者：{{ detailData.authorName }}&nbsp;|&nbsp;{{
              extractDate(detailData.publishTime)
            }}
          </div>
          <div v-if="detailData.introduce" class="ql-editor" v-html="detailData.introduce"></div>
          <div v-if="detailData.content" class="ql-editor" v-html="detailData.content"></div>
<!--          <el-link class="ql-editor" v-if="detailData.attachment" :href="detailData.attachment" target="_blank"-->
<!--                   type="primary">附件-->
<!--          </el-link>-->
          <div v-for="(item,index) in attachment" :key="index">
          <el-link class="fujian" :underline="false" v-if="item.url" :href="item.url" target="_blank" type="primary">
            {{ item.title }}
          </el-link>
          </div>
        </div>
      </div>
    </div>
    <!-- 页面导航 -->
    <div class="pageNav content">
      <div class="pageNav_o">
        <span>上一篇：</span>
        <span v-if="onData.title" @click="goTiaoZ('1')">{{ onData.title }}</span>
        <span v-if="!onData.title">没有更多了</span>
      </div>
      <div class="pageNav_t">
        <span>下一篇：</span>
        <span v-if="underData.title" @click="goTiaoZ('2')">{{ underData.title }}</span>
        <span v-if="!underData.title">没有更多了</span>
      </div>
    </div>
  </div>
</template>
<script>
import home from '../../api/home.js'

export default {
  data () {
    return {
      // 大标题
      bigTitle: '',
      // 内容-标题
      title: '河北东方学院举办“劳模工匠进校园”主题宣讲活动',
      // 内容-时间
      time: '作者： 开发者  | 2024-11-17',
      // 数据
      detailData: {},
      // 上一篇
      onData: {},
      // 下一篇
      underData: {},
      // 附件
      attachment: []
    }
  },
  created () {
    console.log(this.$route.params.id, this.$route.params.tabBarId, 'lllll')
    this.getDetail(this.$route.params.id)
    /**
     *  导航 分页
     * */
    this.getTabBarOne(this.$route.params.id)
    this.getPreviousPage(this.$route.params.id)
    this.getNextPage(this.$route.params.id)
  },
  watch: {
    // 使用字符串路径监听
    '$route.params.id': function (newVal, oldVal) {
      // 当 $route.params.val 发生变化时，这个函数会被调用
      console.log(this.$route.params.id, this.$route.params.tabBarId, 'lllll')
      // 在这里处理变化
      this.getDetail(this.$route.params.id)
      /**
       *  导航 分页
       * */
      this.getTabBarOne(this.$route.params.id)
      this.getPreviousPage(this.$route.params.id)
      this.getNextPage(this.$route.params.id)
    }
  },
  methods: {
    /**
     * 获取单个导航栏
     * */
    getTabBarOne (id) {
      home.getTabBarOne({id})
        .then(res => {
          this.bigTitle = res.data.name
        })
        .catch(e => {
          console.log(e)
        })
    },
    /**
     * 查询上一页
     * */
    getPreviousPage (id) {
      home.getPreviousPage({id})
        .then(res => {
          if (res.previous) {
            this.onData = res.previous
          } else {
            this.onData.title = '没有更多了'
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * 查询下一页
     * */
    getNextPage (id) {
      home.getNextPage({id})
        .then(res => {
          if (res.next) {
            this.underData = res.next
          } else {
            this.underData = '没有更多了'
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 上下篇跳转
    goTiaoZ (val) {
      if (val == 1) {
        if (this.onData.title != '没有更多了') {
          this.$router.push('/news' + '/' + this.onData.id)
          return
        }
      }
      if (val == 2) {
        if (this.underData.title != '没有更多了') {
          this.$router.push('/news' + '/' + this.underData.id)
        }
      }
    },
    // 获取详情
    async getDetail (id) {
      const res = await home.getDetail({id: id})
      if (res.code == 200) {
        this.detailData = res.data
        // this.attachment = res.data.attachment.split(',')
      }
      let arr = []
      const pattern = /附件\d+[^0-9]+/
      arr = res.data.attachment.split(',')
      // console.log(arr)
      if (arr.length != 0) {
        arr.forEach(el => {
          if (!el) return
          this.attachment.push({
            url: el,
            title: el.match(pattern)[0]
          })
        })
      }
      // console.log(this.attachment[0].match(pattern)[0])
      console.log(this.attachment)
      console.log(res)
    },
    routerpush (to) {
      this.$router.push(to)
    },
    // 定义方法来截取年和月，并连在一起
    extractDate (dateTimeStr) {
      if (dateTimeStr) {
        // 使用空格分割日期和时间
        const parts = dateTimeStr.split(' ')
        // 返回日期部分
        return parts[0]
      }
    }
  }
}
</script>
<style lang="less" scoped>
// 内容
.con {
  margin: 50px 0;
  padding-top: 50px !important;

  .con_ {

    .con_title {
      height: 45px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;

      .con_title1 {
        padding: 0 15px;
        line-height: 45px;
        font-size: 20px;
        font-weight: bold;
        color: #444;
        border-bottom: 2px solid #9e070e;
      }

      .con_title2 {
        font-size: 14px;
        color: #666;

        span:nth-child(1) {
          &:hover {
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }

    .con_box {
      margin-top: 20px;
      //text-indent: 2em;
      .con_box_title {
        line-height: 40px;
        font-size: 18px;
        font-weight: bold;
      }

      .con_box_time {
        line-height: 30px;
        font-size: 14px;
        color: #666;
      }

      .con_box_con {
        div {
          p {
            display: flex !important;
            flex-direction: column !important;
          }
        }
      }
    }
  }
}

//页面导航
.pageNav {
  border-top: 1px solid #eee;
  margin-top: 20px;
  height: 80px;
  line-height: 80px;
  white-space: nowrap;
  display: flex;
  flex-wrap: nowrap;

  .pageNav_o {
    display: flex;
    align-items: center;
    max-width: 30%;

    span {
      display: inline-block;

      &:nth-child(1) {
        font-size: 12px;
        color: #999;
      }

      &:nth-child(2) {
        color: #999;
        font-size: 14px;
        cursor: pointer;
        display: inline-block;
        width: 400px;
        overflow: hidden;
        text-overflow: ellipsis;

        &:hover {
          color: #7c2c2c;
        }
      }
    }
  }

  .pageNav_t {
    .pageNav_o
  }
}

.nav:hover {
  background-color: #9e070e;
  color: #fff;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}

.dropdown_menu {
  transform: translate(0, -6%);
  width: 120px;

  .el-dropdown-menu__item {
    text-align: center;
  }

  .el-dropdown-menu__item:hover {
    background-color: #8d080e;
    color: #fff;
  }
}

.content {
  width: 1200px;
  margin: 0 auto;
}

.dropdown:hover {
  background-color: #9e070e;
}

</style>



// WEBPACK FOOTER //
// src/views/news/news.vue